"use strict";

/**
 * import css/sass
 */

import css from "../css/reset.css";
import scss from "../css/main.scss";

/**
 * Services
 */
import clm from "./services/clm";

/**
 * Components
 */
import tab from "./components/tab.js";
import cards from "./components/cards.js";
import banner from "./components/banner.js";
import faq from "./components/faq.js";
import slider from "./components/slider.js";
import modal from "./components/informacoesModal";
import bannerFlutuante from "./components/bannerFlutuante";
import vantagens from "./components/vantagens";
import { pushDataLayerBasicElements } from "./util/pushDataLayer.js";

/**
 * disable clm redirect core
 * clm.init();
 */

if (document.body.classList.contains("home-page")) {
  document.addEventListener("DOMContentLoaded", (event) => {
    let url = document.location.href;
    let isMeuVivo = url.search("cliente-especial-meuvivo") > -1;
    let isPortabilidade = url.search("movimento=portabilidade") > -1;
    let isMktPlace = url.search("acao=portctrlmktplace") > -1;
    let isSmsOffer = url.search("origin=b2c-movel_clm_hyperlink_BAU-SMS") > -1;
    let params = new URLSearchParams(window.location.search);
    const paramAction = params.get("acao");

    document.getElementById("year-copy").innerHTML = new Date().getFullYear();

    var head = document.getElementsByTagName("head")[0];

    if ((!isPortabilidade && isMeuVivo) || paramAction !== "migradotz") {
      const sectionDesconto = document.querySelector(".acao-dotz");
      sectionDesconto.style.display = "none";
    }

    // if (isMeuVivo || paramAction !== "vivopay1") {
    //   const sectionDesconto = document.querySelector(".acao-vivopay1");
    //   sectionDesconto.style.display = "none";
    // }

    // if (isMeuVivo || paramAction !== "vivopay2") {
    //   const sectionDesconto = document.querySelector(".acao-vivopay2");
    //   sectionDesconto.style.display = "none";
    // }

    // if (isMeuVivo || paramAction !== "vivopay3") {
    //   const sectionDesconto = document.querySelector(".acao-vivopay3");
    //   sectionDesconto.style.display = "none";
    // }

    if (!isSmsOffer) {
      // head.removeChild(document.getElementsByTagName('title')[0]);
      // head.removeChild(document.getElementsByTagName('meta').description);
      // head.removeChild(document.getElementsByTagName('meta').keywords);

      document.title =
        "Vivo Controle Site Oficial: Planos com 4.5G | Ligações e WhatsApp ilimitados";

      var description = document.createElement("meta");
      description.name = "description";
      description.content =
        "Com o VIVO Controle você tem internet 4G, SMS ilimitado, ligações ilimitadas para VIVO e minutos para outras operadoras por um valor fixo mensal. Contrate!";

      var keywords = document.createElement("meta");
      keywords.name = "keywords";
      keywords.content =
        "meu plano vivo, planos vivo movel, meu vivo controle, aplicativo vivo controle, vivo ilimitado, vivo controle telefone, app vivo controle, vivo móvel, vivo internet movel, plano controle, melhor internet 4G, vivo sync, vivo controle, planos 4g, plano vivo controle, plano internet controle, perguntas frequentes";

      head.appendChild(description);
      head.appendChild(keywords);
    }

    // if (url.indexOf('cliente-especial-captive') > -1 && (url.search(/plano=29M/gi) > -1 || url.search(/plano=34M/gi) > -1)) {
    //   window.location.href = "https://www.vivo.com.br/para-voce/produtos-e-servicos/para-o-celular/vivo-controle/planos-controle";
    // }

    if (isMeuVivo) {
      let $meuvivoItens = document.querySelectorAll(".oferta-meuvivo");
      let $regs = document.querySelectorAll(
        ".modal--content--abas--aba--regulamento"
      );

      // let $mktItens = document.querySelectorAll('.oferta-mktplace');

      $meuvivoItens.forEach(($meuvivoItem) => {
        $meuvivoItem.classList.remove("oferta-meuvivo");
      });

      if (isPortabilidade && isMktPlace) {
        [...$regs].forEach((reg) => {
          if (!reg.classList.contains("oferta-mktplace")) {
            reg.style.display = "none";
          } else {
            reg.style.display = "block";
          }
        });
      }

      if (isPortabilidade && !isMktPlace) {
        [...$regs].forEach((reg) => {
          if (!reg.classList.contains("oferta-portabilidade")) {
            reg.style.display = "none";
          } else {
            reg.style.display = "block";
          }
        });
      }
    } else {
      let $captiveItens = document.querySelectorAll(".oferta-captive");

      $captiveItens.forEach(($captiveItem) => {
        $captiveItem.classList.remove("oferta-captive");
      });
    }
  });

  /**
   * banners
   */
  banner.init();

  /**
   * cards
   */
  cards.buildCards();
  cards.bind();

  /**
   * tabs
   */
  tab.bind();

  /**
   * Modal Informações
   */
  modal.init();

  /**
   * Clique e conheça
   */
  vantagens.init();

  pushDataLayerBasicElements();
}

if (document.body.classList.contains("vantagens-page")) {
  let isMobile = window.innerWidth <= 1023 ? true : false;
  /**
   * slider
   */
  // if (isMobile) {
  //   slider.buildSliderAppsControle();
  // }
  /**
   * faq
   */
  faq.buildFaq();
  faq.buildAccordion();

  /**
   * Banner Flutuante
   */
  bannerFlutuante.init();
}
